function stripTrailingZeros() {
  document.querySelectorAll('.product-actual-price, .product-compare-price, .product-price, .price-item').forEach(function(el) {
    el.childNodes.forEach(function(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        node.textContent = node.textContent.replace(/\.00(?=\s*$|\D|$)/g, '');
      }
    });
  });
}

const priceObserver = new MutationObserver(function() {
  stripTrailingZeros();
});

document.addEventListener('DOMContentLoaded', function() {
  stripTrailingZeros();
  priceObserver.observe(document.body, { childList: true, subtree: true });
});